import React from "react";

import type { MonitorCheckStatusExternalSilencingRule } from "../../../../../../common/openapi";

import { ActiveRulesAlert } from "./common/active-rules-alert";
import { AppliesTo } from "./common/applies-to";
import { CannotRemoveRuleAlert } from "./common/cannot-remove-rule-alert";
import { ExternalRuleTiming } from "./common/external-rule-timing";
import { RuleSelector } from "./common/rule-selector";
import { SilencingNote } from "./common/silencing-note";

export function ExternalLiveWithSelector({ rule }: { rule: MonitorCheckStatusExternalSilencingRule }) {
	return (
		<div className="drawer-body flex flex-col gap-6">
			<ActiveRulesAlert />
			<RuleSelector />
			<CannotRemoveRuleAlert />
			<ExternalRuleTiming rule={rule} />
			<SilencingNote note={rule.note} />
			<AppliesTo />
		</div>
	);
}
